import React from 'react';
import PropTypes from 'prop-types';
import { lightFormat } from 'date-fns';
import { enUS, es } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import NotificationRowContent from 'components/notifications/NotificationRowContent';
import { dateFormat, timeFormat } from 'common/constants/date';
import { convertUtcToLocalTime } from 'common/utils/date';

function SessionCreatedNotification({ notification }) {
  const { t, i18n } = useTranslation(['notifications']);
  const dateLocale = i18n.language === 'es' ? es : enUS;

  const {
    data: {
      session: { start_date: startDate, user }
    }
  } = notification;

  const startDateObj = new Date(startDate);
  const date = convertUtcToLocalTime(startDateObj, dateFormat, dateLocale);
  const time = lightFormat(startDateObj, timeFormat);

  return (
    <NotificationRowContent
      notification={notification}
      user={user}
      title={user.full_name}
      body={t('session.created', { user: user.full_name, date, time, ns: 'notifications' })}
    />
  );
}

SessionCreatedNotification.propTypes = {
  notification: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    data: PropTypes.shape({
      session: PropTypes.shape({
        id: PropTypes.number.isRequired,
        start_date: PropTypes.string.isRequired,
        user: PropTypes.shape({
          first_name: PropTypes.string.isRequired,
          full_name: PropTypes.string.isRequired,
          last_name: PropTypes.string.isRequired,
          photo: PropTypes.string
        }).isRequired
      }).isRequired
    }).isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired
};

export default SessionCreatedNotification;
